import { useState } from 'react'
import ReactDOM from "react-dom";
import { useSelector } from 'react-redux'

import Button from '../../../common/Button'
import NotesVertical from './NotesVertical'
import Card from '../../../common/Card'
import OutsideClickComponent from '../../../fragments/OutsideClickComponent'
import Backdrop from "../../../common/modal/Backdrop"
import Modal from "../../../common/Modal"
import AddNotes from "./AddNotes"

import classes from './NotesComponent.module.css'

const NotesComponent = ({ noteTypeId, inWorkQ }) => {
    const [openNotes, setOpenNotes] = useState(false)
    const [isModalOpened, setisModalOpened] = useState(false)

    const activeCase = useSelector(state => state.case.activeCase)

    if (inWorkQ) {
        return null
    }

    const openNoteshandler = () => {
        setOpenNotes(prevState => prevState = !prevState)
    }

    const closeNotesHandler = () => {
        setOpenNotes(false)
    }

    const openModalHandler = () => {
        setisModalOpened(true)
    }

    const closeModalHandler = () => {
        setisModalOpened(false)
    }

    return <div className={classes.container}>
        <Button click={openNoteshandler} btnStyle={openNotes ? 'btn_dark' : ''} isDisabled={openNotes} bypassisCaseArchived={true}>
            <i className='ti ti-notes'></i>
            {openNotes ? 'Hide Notes' : 'View Notes'}
        </Button>

        {openNotes && <OutsideClickComponent task={closeNotesHandler}>
            <div className={classes.notes_container}>
                <Card>
                    <NotesVertical noteTypeId={noteTypeId} openModal={openModalHandler}/>     
                </Card>   
            </div>    
        </OutsideClickComponent>}


        {isModalOpened && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeModalHandler} noBlur />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <AddNotes data={activeCase} closeModal={closeModalHandler} selectedNoteTypeId={noteTypeId}/>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    </div>
}

export default NotesComponent